import { Flex } from '@mantine/core';
import { IconBuildingStore } from '@tabler/icons-react';

const StoreAvatar: React.FC = () => (
  <Flex p={10} display="flex" bdrs="50%" align="center" justify="center" bg="gray.1">
    <IconBuildingStore size={20} />
  </Flex>
);

export default StoreAvatar;
